import { ActionType, createAction } from 'typesafe-actions';
import { LocalizationKeys, NeverTranslated } from '../../../i18n';

type ThrowPayload = {
  id: MessageId;
  values: Record<string, React.ReactNode> | undefined;
  options: {
    isRefreshAction: boolean;
    isPersistent: boolean;
    // Reuse a stable toast id so repeated identical messages replace
    // each other instead of stacking.
    deduplicate: boolean;
  };
};

export type MessageId<K extends string = LocalizationKeys> =
  | (K extends `containers.message.${infer A}` ? A : never)
  // oxlint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  | NeverTranslated<`containers.message.%`>;

export const throwError = createAction(
  'TOAST_MESSAGE',
  (id: MessageId, values?: object, options: object = {}) => ({
    id,
    values,
    options,
  }),
  (_id: MessageId, _values?: object, _options: object = {}) => ({
    type: 'error',
  })
)<ThrowPayload, { type: 'error' }>();

export const throwInfo = createAction(
  'TOAST_MESSAGE',
  (id: MessageId, values?: object, options: object = {}) => ({
    id,
    values,
    options,
  }),
  (_id: string, _values?: object, _options: object = {}) => ({
    type: 'default',
  })
)<ThrowPayload, { type: 'default' }>();

export type MessagesActions = ActionType<typeof throwError | typeof throwInfo>;
